import { useState } from 'react';

import { useNavigate } from 'libs/navigation';

const SEARCH_PARAM_KEY = 'tab';

function getTabNumberBySearchParams(searchParams: URLSearchParams) {
  const tabNumber = Number(searchParams.get(SEARCH_PARAM_KEY));

  if (
    Number.isNaN(tabNumber) ||
    !Number.isInteger(tabNumber) ||
    tabNumber < 1
  ) {
    return 1;
  }

  return tabNumber;
}

/**
 * Hook to manage tab navigation with URL query parameter.
 */
export const useTabsNavigate = () => {
  const { searchParams } = useNavigate();

  const [currentTabNumber, setCurrentTabNumber] = useState(() =>
    getTabNumberBySearchParams(searchParams)
  );

  const goToTab = (tabNumber: number) => {
    searchParams.set(SEARCH_PARAM_KEY, tabNumber.toString());
    window.history.replaceState(null, '', `?${searchParams.toString()}`);
    setCurrentTabNumber(tabNumber);
  };

  return { goToTab, currentTabNumber };
};
